module.exports = __webpack_public_path__ + "img/galerie-3.0942fc80.jpg";